import { ReactComponent as PlusAltIconSVG } from '@/assets/icons/PlusAltIcon.svg';
import { SVGProps } from 'react';

const PlusAltIcon = (props: SVGProps<SVGSVGElement>) => <PlusAltIconSVG {...props} />;

export default PlusAltIcon;
